<template>
  <div class="list-cards">
    <switch-card
      type="passportVerification"
      :action-for-update-data="updateStatusPassportVerify"/>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import SwitchCard from './SwitchCard/SwitchCard'
import '@/assets/sass/style/components/pages/settings/switchCard.scss'

export default {
  name: 'PassportVerification',
  components: {
    SwitchCard
  },
  computed: {
    ...mapGetters({
      verification: 'superadministrator/passportVerification'
    })
  },
  methods: {
    ...mapActions({
      updateStatusPassportVerify: 'superadministrator/updateStatusPassportVerify'
    })
  }
}
</script>

<style scoped>

</style>
